// extracted by mini-css-extract-plugin
export default {"address":"Address_address__lKrs+","form":"Address_form__KIdZ1","flexip":"Address_flexip__BW+SF","flexbtn":"Address_flexbtn__dT63y","flexp":"Address_flexp__CPsyi"};